// extracted by mini-css-extract-plugin
export default {"container":"ModalMenu_container__43dzB","contMenu":"ModalMenu_contMenu__wgsqW","menu":"ModalMenu_menu__jgCvU","a":"ModalMenu_a__qZL+l"};